<template>
    <div class="container is-fullhd">
      <div class="section">
        <div class="tile is-ancestor">
        <div class="tile is-parent">
          <div class="tile notification is-secondary is-child left-tile-discover">
            <div class="content">
              <p class="title">Bookman Discover 👀</p>
              <p class="subtitle">Find New Books To Read</p>
            </div>
          </div>
        </div>
        <div class="tile is-parent">
          <div class="tile notification is-secondary is-child">
            <div class="content">
              <p class="title">A New Way To Read</p>
              <p class="subtitle">Read up to 33% of selected ebooks</p>
            </div>
          </div>
        </div>
      </div>
      <chunked-ebooks-display :ebooks="discoverEbooks"/>
    </div>
  </div>
</template>

<script>
import chunkedEbooksDisplay from '@/components/chunked-ebooks-display'

export default {
  name: 'discover',
  created () {
    this.$store.dispatch('loadDiscoverEbooks', { limit: null })
  },
  computed: {
    discoverEbooks () {
      return this.$store.getters.getEbooksList
    }
  },
  components: {
    chunkedEbooksDisplay
  }
}
</script>

<style>
.left-tile-discover {
  background-image: radial-gradient( circle farthest-corner at 0.8% 1.8%,  rgba(255,104,107,1) 0%, rgba(255,187,103,1) 90.1% );
}
</style>
